import { create } from "zustand";
const GUID = localStorage.getItem("vendorGUID");
   const VendorType = localStorage.getItem("VendorType") === "Trade";


const mapVendorApiToFormData = (api, vendor) => ({
  vendorGUID: api?.VendorGUID || vendor?.VendorGUID || GUID || "",
  panNumber: api?.PANNumber || "",
  vendorName: vendor?.VendorName ?? api?.VendorName,
  businessCategory: api?.BusinessCategory || null,
  // proprietorName: api?.ProprietorName || "", // not coming from API
  vendorType: vendor?.VendorType ?? api?.VendorType,
  vendorDivision: vendor?.Division ?? api?.VendorDivision,
  productIntroduced: api?.ProductIntroduced || "",
  addresses: (api?.VendorGeneralAddressDto || [])?.map((addr) => ({
    addressType: addr?.AddressType,
    addressLine1: addr?.AddressLine1 || "",
    addressLine2: addr?.AddressLine2 || "",
    addressLine3: addr?.AddressLine3 || "",
    addressLine4: addr?.AddressLine4 || "",
    pincode: addr?.Pincode || "",
    country: addr?.Country || null,
    state: addr?.State || null,
    city: addr?.City || "",
  })),
});

export const useGenralInfoFormStore = create((set, get) => ({
  formData: {
    vendorGUID: GUID || "",
    panNumber: "",
    vendorName: "",
    businessCategory: null,
    // proprietorName: "",
    vendorType: null,
    vendorDivision: null,
    productIntroduced: "",
    addresses: [
      {
        addressType: "REGISTERED_HO",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        // addressLine4: "",
        pincode: "",
        country: null,
        state: null,
        city: "",
      },
    ],
  },

  errors: {},
  panError: "",
  setVendorFromApi: (apiResponse, vendor) =>
    set(() => ({
      formData: mapVendorApiToFormData(apiResponse, vendor),
    })),

  setFormData: (data) =>
    set((state) => ({
      formData: {
        ...state.formData,
        ...data,
      },
      errors: {},
    })),

  // Update any simple field
  // setField: (field, value) =>
  //   set((state) => ({
  //     formData: {
  //       ...state.formData,
  //       [field]:
  //         field === "vendorGUID"
  //           ? value // DO NOT uppercase GUID
  //           : typeof value === "string"
  //             ? value.toUpperCase()
  //             : value,
  //     },
  //     errors: { ...state.errors, [field]: "" },
  //   })),
  setField: (field, value) =>
    set((state) => {
      const noCaseTransformFields = ["vendorGUID"];

      return {
        formData: {
          ...state.formData,
          [field]: noCaseTransformFields.includes(field)
            ? value
            : typeof value === "string"
            ? value.toUpperCase()
            : value,
        },
        errors: { ...state.errors, [field]: "" },
        ...(field === "panNumber" && { panError: "" }),
      };
    }),

  // Update address
  setAddressField: (addressType, field, value) =>
    set((state) => {
      const uppercaseValue = typeof value === "string" ? value : value;
      const addresses = [...state.formData.addresses];
      const index = addresses.findIndex((a) => a.addressType === addressType);

      if (index !== -1) {
        // Update existing
        addresses[index] = {
          ...addresses[index],
          [field]: uppercaseValue,
        };
      } else {
        // Create new
        addresses.push({
          addressType,
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          pincode: "",
          country: null,
          state: null,
          city: "",
          [field]: uppercaseValue,
        });
      }

      return {
        formData: {
          ...state.formData,
          addresses,
        },
        errors: { ...state.errors, [field]: "" },
      };
    }),

  // Copy Registered HO
  copyAddress: (targetType) =>
    set((state) => {
      const registered = state.formData.addresses.find(
        (a) => a.addressType === "REGISTERED_HO"
      );
      if (!registered) return state;

      const newAddr = { ...registered, addressType: targetType };

      const updated = [...state.formData.addresses];
      const idx = updated.findIndex((a) => a.addressType === targetType);

      if (idx !== -1) updated[idx] = newAddr;
      else updated.push(newAddr);

      return {
        formData: {
          ...state.formData,
          addresses: updated,
        },
      };
    }),
  // Remove / clear address by type
  clearAddress: (addressType) =>
    set((state) => ({
      formData: {
        ...state.formData,
        addresses: state.formData.addresses.filter(
          (a) => a.addressType !== addressType
        ),
      },
    })),

  // Reset form
  resetForm: () =>
    set(() => ({
      formData: {
        vendorGUID: "",
        panNumber: "",
        vendorName: "",
        businessCategory: null,
        // proprietorName: "",
        vendorType: null,
        vendorDivision: null,
        productIntroduced: "",
        addresses: [],
      },
      errors: {},
      panError: "",
    })),

  // Set errors
  setErrors: (errors) => set({ errors }),
  setPanError: (error) =>
    set((state) => ({
      panError: error,
      errors: {
        ...(state.errors || {}),
        panNumber: error, // ✅ THIS IS CRITICAL
      },
    })),

  validateForm: () => {
    const state = get();
    const formData = state.formData;
    const newErrors = {};
    const panError = state.panError;
    const errors = get();

    // General Information
    if (!formData?.panNumber) {
      newErrors.panNumber = "PAN Number is required";
    } else if (panError) {
      newErrors.panNumber = panError; // ✅ BLOCK if panError exists
    }
    if (errors?.panNumber) {
      newErrors.panNumber = errors.panNumber;
    }
    if (!formData?.vendorName) newErrors.vendorName = "Vendor Name is required";
    if (!formData?.businessCategory)
      newErrors.businessCategory = "Vendor Category is required";

    if (!formData?.vendorType) newErrors.vendorType = "Vendor Type is required";
    // if (!formData?.vendorDivision ||!VendorType)
    //   newErrors.vendorDivision = "Vendor Division is required";
    // if (!formData.productIntroduced)
    //   newErrors.productIntroduced = "Product to be introduced is required";
    // if (!formData.priceAndMargin)
    //   newErrors.priceAndMargin = "Price and Margin detail is required";
    // if (!formData.totAgreement)
    //   newErrors.totAgreement = "Tot Agreement is required";

    // Registered HO Address
    const hoAddress = formData.addresses.find(
      (a) => a.addressType === "REGISTERED_HO"
    );

    if (!hoAddress?.city) newErrors.city = "City is required";
    if (!hoAddress?.state) newErrors.state = "State is required";
    if (!hoAddress?.country) newErrors.country = "Country is required";
    if (!hoAddress?.pincode) newErrors.pincode = "Pin Code is required";
    if (!hoAddress?.addressLine1)
      newErrors.addressLine1 = "Address Line 1 is required";
    if (!hoAddress?.addressLine2)
      newErrors.addressLine2 = "Address Line 2 is required";
    if (!hoAddress?.addressLine3)
      newErrors.addressLine3 = "Address Line 3 is required";

    // Save errors in store
    set({ errors: newErrors });

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  },
}));
